import { ReactElement } from 'react';
import { styled } from 'styled-components';
import { PlaybackRate } from '../../hooks/useAudioPlayer';
import formatPlaybackRate, { PLAYBACK_RATE_OPTIONS } from '../../utils/formatPlaybackRate';

const SpeedButtons = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

interface SpeedButtonProps {
  active: boolean;
}

const SpeedButton = styled.button<SpeedButtonProps>`
  padding: 4px 12px;
  font-size: 12px;
  border: 1px solid ${(props: SpeedButtonProps) => (props.active ? '#1890ff' : '#d9d9d9')};
  background-color: ${(props: SpeedButtonProps) => (props.active ? '#e6f7ff' : '#ffffff')};
  color: ${(props: SpeedButtonProps) => (props.active ? '#1890ff' : '#666')};
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    border-color: #1890ff;
    color: #1890ff;
  }

  &:focus {
    outline: 2px solid #1890ff;
    outline-offset: 2px;
  }
`;

interface Props {
  currentRate: PlaybackRate;
  onRateChange: (rate: PlaybackRate) => void;
}

const PlaybackRateControl = ({ currentRate, onRateChange }: Props): ReactElement => {
  return (
    <SpeedButtons>
      {PLAYBACK_RATE_OPTIONS.map(rate => (
        <SpeedButton
          key={rate}
          active={rate === currentRate}
          onClick={() => {
            onRateChange(rate);
          }}
        >
          {formatPlaybackRate(rate)}
        </SpeedButton>
      ))}
    </SpeedButtons>
  );
};

export default PlaybackRateControl;
